<app-loader></app-loader>
<router-outlet>

</router-outlet>
<p-toast></p-toast>